<template>
    <div class="modul-form">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Modul Pembelajaran',
                    to: { path: '/modul-pembelajaran' },
                    exact: true,
                },
                {
                    text: !$route.query.id
                        ? 'Tambah Modul Belajar'
                        : 'Ubah Modul Belajar',
                },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">
            {{ !$route.query.id ? "Tambah Modul Baru" : "Ubah Modul" }}
        </h3>

        <v-card plain class="pa-7">
            <v-skeleton-loader
                v-if="isFetchingDetail"
                type="article, list-item-two-line@4, actions"
            ></v-skeleton-loader>

            <div v-else-if="detailError" class="py-10 text-center">
                <v-icon size="48" color="grey lighten-1">
                    mdi-alert-circle-outline
                </v-icon>
                <div class="font-weight-bold mt-3 black--text">
                    Gagal memuat data modul
                </div>
                <div class="mt-1">Periksa koneksi Anda, lalu coba lagi.</div>
                <v-btn
                    class="mt-4 mr-2"
                    depressed
                    small
                    @click="$router.push('/modul-pembelajaran')"
                >
                    Kembali
                </v-btn>
                <v-btn
                    class="mt-4 blew white--text"
                    depressed
                    small
                    @click="fetchDetail()"
                >
                    Coba Lagi
                </v-btn>
            </div>

            <v-form v-else ref="form" lazy-validation>
                <div class="caption grey--text text--darken-1 mb-4">
                    Kolom bertanda <span class="red--text">*</span> wajib diisi.
                </div>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Nama Modul <span class="red--text">*</span>
                        </v-list-item-title>
                        <v-text-field
                            placeholder="Nama Modul Belajar"
                            v-model="form.name"
                            outlined
                            :rules="[
                                (v) =>
                                    !!(v && v.trim()) ||
                                    'Nama Modul wajib diisi',
                            ]"
                        />
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Mata Pelajaran <span class="red--text">*</span>
                        </v-list-item-title>
                        <v-select
                            class="pa-0"
                            v-model="mapel"
                            :items="mapelList"
                            outlined
                            item-text="nama"
                            return-object
                            placeholder="Ketik mata pelajaran"
                            no-data-text="Data mata pelajaran tidak tersedia"
                            chips
                            :rules="[
                                (v) => !!v || 'Mata Pelajaran wajib dipilih',
                            ]"
                            @change="getItembanks"
                        >
                            <template v-slot:selection="{ item }">
                                <v-list-item class="pa-0 ma-0">
                                    <v-list-item-avatar class="my-0 ml-0 mr-3">
                                        <img :src="item.picture" />
                                    </v-list-item-avatar>
                                    <v-list-item-title>{{
                                        item.nama
                                    }}</v-list-item-title>
                                </v-list-item>
                            </template>
                            <template v-slot:item="{ item }">
                                <v-list-item-avatar>
                                    <img :src="item.picture" />
                                </v-list-item-avatar>
                                <v-list-item-title>{{
                                    item.nama
                                }}</v-list-item-title>
                            </template>
                        </v-select>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Topik <span class="red--text">*</span>
                        </v-list-item-title>
                        <app-autocomplete
                            placeholder="Cari Bab / (Sub) Sub Bab"
                            :data="topics"
                            :rules="[
                                (v) => !!(v && v.id) || 'Topik wajib dipilih',
                            ]"
                            v-on:selected="assignTopic($event)"
                            :value="topic"
                            :topic="
                                subSubBabId
                                    ? subSubBabId
                                    : subBabId
                                    ? subBabId
                                    : babId
                            "
                        ></app-autocomplete>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Jenjang <span class="red--text">*</span>
                        </v-list-item-title>

                        <v-radio-group
                            row
                            v-model="form.jenjang"
                            :rules="[(v) => !!v || 'Jenjang wajib dipilih']"
                            @change="resetKelas()"
                        >
                            <v-radio
                                v-for="item in jenjangList"
                                v-bind:key="item"
                                :label="item"
                                :value="item"
                                class="jenjang-selection"
                                active-class="act-radio-btn"
                            ></v-radio>
                        </v-radio-group>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0" v-if="form.jenjang">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Kelas <span class="red--text">*</span>
                        </v-list-item-title>
                        <v-input
                            :value="kelas"
                            :rules="[
                                () =>
                                    selectedGrades.length > 0 ||
                                    'Kelas wajib dipilih minimal satu',
                            ]"
                        >
                            <div class="d-inline">
                                <v-checkbox
                                    v-for="grade in validGrades"
                                    :key="grade"
                                    :label="String(grade)"
                                    :value="grade"
                                    v-model="kelas"
                                    class="pa-2 ma-0 d-inline-flex"
                                    hide-details
                                />
                            </div>
                        </v-input>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Status User <span class="red--text">*</span>
                        </v-list-item-title>
                        <v-radio-group
                            row
                            v-model="form.status_user"
                            :rules="[(v) => !!v || 'Status User wajib dipilih']"
                        >
                            <v-radio
                                id="live_class_type_free"
                                label="FREE"
                                value="FREE"
                                class="jenjang-selection"
                                active-class="act-radio-btn"
                            ></v-radio>
                            <v-radio
                                id="live_class_type_premium"
                                label="PREMIUM"
                                value="PREMIUM"
                                class="jenjang-selection"
                                active-class="act-radio-btn"
                            ></v-radio>
                        </v-radio-group>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Kurikulum <span class="red--text">*</span>
                        </v-list-item-title>
                        <v-radio-group
                            row
                            v-model="form.kurikulum"
                            :rules="[(v) => !!v || 'Kurikulum wajib dipilih']"
                        >
                            <v-radio
                                label="KM"
                                value="KM"
                                class="pa-2 ma-0 d-inline-flex"
                                outlined
                            />
                            <v-radio
                                label="K13"
                                value="K13"
                                class="pa-2 ma-0 d-inline-flex"
                                outlined
                            />
                            <v-radio
                                label="K13 IPA"
                                value="saintek"
                                class="pa-2 ma-0 d-inline-flex"
                                outlined
                            />

                            <v-radio
                                label="K13 IPS"
                                value="soshum"
                                class="pa-2 ma-0 d-inline-flex"
                                outlined
                            />
                            <v-radio
                                label="TKA"
                                value="TKA"
                                class="pa-2 ma-0 d-inline-flex"
                                outlined
                            />
                        </v-radio-group>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Semester <span class="red--text">*</span>
                        </v-list-item-title>

                        <v-radio-group
                            row
                            v-model="form.semester"
                            :rules="[(v) => !!v || 'Semester wajib dipilih']"
                        >
                            <v-radio
                                label="Ganjil"
                                value="GANJIL"
                                class="jenjang-selection"
                                active-class="act-radio-btn"
                            ></v-radio>
                            <v-radio
                                label="Genap"
                                value="GENAP"
                                class="jenjang-selection"
                                active-class="act-radio-btn"
                            ></v-radio>
                        </v-radio-group>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="px-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Upload PDF <span class="red--text">*</span>
                        </v-list-item-title>
                        <v-input
                            :value="presentationPath"
                            :rules="[(v) => !!v || 'File PDF wajib diunggah']"
                        >
                            <v-card outlined class="flex-grow-1 pdf-card">
                                <div class="d-flex align-center pa-3">
                                    <v-icon
                                        :color="presentationPath ? 'red' : 'grey'"
                                        class="mr-3"
                                    >
                                        mdi-file-pdf-box
                                    </v-icon>
                                    <span class="text-truncate flex-grow-1">
                                        {{
                                            pdfFile
                                                ? pdfFile.name
                                                : presentationPath
                                                ? "File PDF tersimpan"
                                                : "Belum ada file dipilih (format .pdf)"
                                        }}
                                    </span>
                                    <v-btn
                                        @click="$refs.uploader2.click()"
                                        class="blew--text font-weight-bold ml-3"
                                        color="#e8f5fa"
                                        depressed
                                    >
                                        <v-icon left>mdi-upload</v-icon>
                                        {{
                                            presentationPath
                                                ? "Ganti File"
                                                : "Upload File"
                                        }}
                                    </v-btn>
                                    <input
                                        type="file"
                                        ref="uploader2"
                                        class="d-none"
                                        accept="application/pdf"
                                        @change="onFileChange"
                                    />
                                </div>
                                <template v-if="presentationPath">
                                    <v-divider></v-divider>
                                    <embed
                                        :src="presentationPath"
                                        type="application/pdf"
                                        class="pdf-preview"
                                    />
                                </template>
                            </v-card>
                        </v-input>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Password PDF
                        </v-list-item-title>
                        <v-text-field
                            placeholder="Password PDF"
                            v-model="form.password"
                            outlined
                        />
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pa-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            Status <span class="red--text">*</span>
                        </v-list-item-title>
                        <v-radio-group
                            row
                            v-model="form.status"
                            :rules="[(v) => !!v || 'Status wajib dipilih']"
                        >
                            <v-radio
                                label="Draft"
                                value="DRAFT"
                                class="jenjang-selection"
                                active-class="act-radio-btn"
                            ></v-radio>
                            <v-radio
                                label="Review"
                                value="REVIEW"
                                class="jenjang-selection"
                                active-class="act-radio-btn"
                            ></v-radio>
                            <v-radio
                                label="Publikasi"
                                value="PUBLISHED"
                                class="jenjang-selection"
                                active-class="act-radio-btn"
                            ></v-radio>
                        </v-radio-group>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item two-line class="pa-0">
                    <v-list-item-content class="pt-0 px-0">
                        <v-list-item-title class="font-weight-bold pb-2">
                            User Group <span class="red--text">*</span>
                        </v-list-item-title>
                        <v-autocomplete
                            :items="user_groups"
                            item-text="user_group_name"
                            item-value="id"
                            placeholder="-- Pilih user group --"
                            :loading="isFetchingUserGroups"
                            no-data-text="Data user group tidak tersedia"
                            outlined
                            :rules="[(v) => !!v || 'User Group wajib dipilih']"
                            v-for="(usgr, i) in form.user_group"
                            :key="i"
                            v-model="form.user_group[i]"
                        >
                            <template v-slot:append-outer>
                                <v-btn
                                    id="user-remove-scope-btn"
                                    dark
                                    large
                                    class="font-weight-bold dark--text"
                                    depressed
                                    color="white"
                                    v-if="
                                        i === form.user_group.length - 1 &&
                                        form.user_group.length != 1
                                    "
                                    @click="
                                        queryId
                                            ? null
                                            : form.user_group.splice(i, 1)
                                    "
                                >
                                    Hapus
                                </v-btn>
                            </template>
                        </v-autocomplete>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <v-btn
                    id="user-add-scope-btn"
                    @click="form.user_group.push('')"
                    block
                    depressed
                    class="font-weight-bold blew--text mb-5 mt-8"
                    color="#e8f5fa"
                >
                    <v-icon style="font-size: 16px !important" class="mr-1">
                        mdi-plus-circle
                    </v-icon>
                    Tambah User Group Baru
                </v-btn>
                <v-btn
                    block
                    class="font-weight-bold blew--text mb-1"
                    depressed
                    color="#e8f5fa"
                    @click="openOrderDialog()"
                >
                    <v-icon style="font-size: 22px !important" class="mr-1">
                        mdi-sort-bool-ascending-variant
                    </v-icon>
                    Atur Urutan Modul
                </v-btn>
                <div class="caption grey--text text--darken-1 mb-5">
                    {{
                        form.module_order
                            ? "Nomor urut: " + form.module_order
                            : "Nomor urut otomatis di urutan terakhir pada bab dan kelas yang sama."
                    }}
                </div>

                <v-card-actions class="py-2">
                    <v-spacer></v-spacer>

                    <v-btn
                        color="primary"
                        class="mt-3"
                        depressed
                        :loading="isLoading"
                        :disabled="isLoading"
                        @click="onSubmit()"
                    >
                        Simpan
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>

        <v-dialog v-model="dialogConfirm.open" persistent max-width="506px">
            <v-card>
                <v-card-title
                    class="text-h5"
                    style="word-break: break-word !important"
                >
                    {{ dialogConfirm.title }}
                </v-card-title>
                <v-card-text>
                    {{ dialogConfirm.subtitle }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="darkFade"
                        text
                        @click="dialogConfirm.open = false"
                    >
                        Batal
                    </v-btn>
                    <v-btn
                        color="blew"
                        text
                        @click="
                            onSubmit();
                            dialogConfirm.open = false;
                        "
                    >
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="showModal"
            transition="dialog-top-transition"
            width="940px"
            min-height="537px"
            max-height="771px"
            @click:outside="showModal = false"
        >
            <template v-slot:default="dialog">
                <v-card>
                    <v-card-title>
                        Urutan Modul Belajar
                        <span class="ml-2 font-weight-regular">
                            (Bab {{ currentBabName }}
                            <span class="blew--text">Kelas {{ orderGrade }}</span>)
                        </span>
                        <v-spacer></v-spacer>

                        <v-progress-circular
                            v-if="loadingSequence"
                            indeterminate
                            color="primary"
                            :size="30"
                        ></v-progress-circular>

                        <v-icon
                            v-if="updatedSequence && !loadingSequence"
                            color="blew"
                            style="font-size: 32px"
                            >mdi-check-circle</v-icon
                        >
                    </v-card-title>
                    <v-card-subtitle>
                        <div>
                            Atur urutan dengan drag list modul. Urutan berlaku
                            untuk modul dalam bab dan kelas yang sama.
                        </div>
                        <div class="mt-5 mb-5">
                            <v-btn
                                v-for="grade in selectedGrades"
                                :key="grade"
                                :color="
                                    orderGrade === grade ? '#e8f5fa' : '#f3f5f7'
                                "
                                :class="
                                    orderGrade === grade
                                        ? 'blew--text'
                                        : 'grey--text'
                                "
                                depressed
                                rounded
                                class="mr-2"
                                @click="
                                    orderGrade = grade;
                                    loadOrderList();
                                "
                            >
                                Kelas {{ grade }}
                            </v-btn>
                        </div>
                    </v-card-subtitle>
                    <v-card-text width="100%">
                        <div class="mt-3 mb-5 pl-4 font-weight-bold">
                            <v-row>
                                <v-col cols="2">Nomor Urut</v-col>
                                <v-col cols="8">Nama Modul</v-col>
                            </v-row>
                        </div>

                        <div v-if="isFetchingModuls" class="mt-8">
                            <v-skeleton-loader type="card"></v-skeleton-loader>
                        </div>

                        <div v-else>
                            <draggable
                                :list="modul2"
                                :disabled="loadingSequence"
                                class="list-group"
                                ghost-class="ghost"
                                @end="finishDragged"
                            >
                                <div
                                    v-for="(modul, index) in modul2"
                                    :key="modul.id"
                                    class="list-group-item pa-6 draggable"
                                    :class="modul.current ? 'selected' : ''"
                                >
                                    <v-row>
                                        <v-col cols="2" md="2">
                                            <v-btn
                                                :color="
                                                    modul.current
                                                        ? 'white'
                                                        : 'blew'
                                                "
                                                class="font-weight-bold"
                                                :class="
                                                    modul.current
                                                        ? 'teal--text text--darken-1'
                                                        : ''
                                                "
                                                style="font-size: 14px"
                                                rounded
                                                fab
                                                x-small
                                                :dark="!modul.current"
                                                depressed
                                            >
                                                {{ index + 1 }}
                                            </v-btn>
                                        </v-col>
                                        <v-col
                                            cols="8"
                                            md="8"
                                            class="pt-1"
                                            :class="{
                                                'font-weight-bold':
                                                    modul.current,
                                            }"
                                        >
                                            {{ modul.name }}
                                        </v-col>
                                    </v-row>
                                </div>

                                <div class="text-center" v-if="!modul2.length">
                                    Modul tidak tersedia
                                </div>
                            </draggable>
                        </div>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn text @click="dialog.value = false">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import _ from "lodash";
import Autocomplete from "@/modules/global/components/plugins/Autocomplete";
import AWS from "aws-sdk";
import { applyOssCredentials } from "@/modules/global/services/oss";
import DataTable from "@/modules/global/components/plugins/DataTable";
import ItembankService from "@/modules/itembank/services/itembank.js";
import MarkdownEditor from "@/modules/global/components/plugins/MarkdownEditor-c";
import Modal from "@/modules/global/components/plugins/Modal";
import ModulPembelajaranService from "@/modules/modul_belajar_2022/services/modulpembelajaran";
import Spinner from "@/modules/global/components/plugins/Spinner";
import uniqid from "uniqid";
import axios from "axios";
import draggable from "vuedraggable";

export default {
    name: "ModulPembelajaranForm",

    components: {
        "app-autocomplete": Autocomplete,
        "app-datatable": DataTable,
        "app-editor": MarkdownEditor,
        "app-modal": Modal,
        "app-spinner": Spinner,
        draggable,
    },

    data: function () {
        return {
            url: null,
            newForm: true,
            startDate: null,
            startTime: null,
            isLoading: false,
            isFetchingDetail: false,
            detailError: false,
            isFetchingModuls: false,
            isFetchingUserGroups: false,
            filepdf: null,
            formkey: 0,
            videoKey: 0,
            soalKey: 0,
            presentationPath: null,
            form: {
                name: "",
                subject: "",
                bab: "",
                sub_bab: "",
                sub_sub_bab: "",
                module_order: "",
                reading_material: "",
                semester: "",
                grades: [],
                password: "",
                jenjang: "",
                status: "",
                // Minimal satu slot agar kolom wajib User Group selalu tampil
                user_group: [""],
                status_user: "",
                kurikulum: "",
                url: "",
            },
            queryId: null,
            pdfFile: null,
            itemUrl: "",
            imgurls: [],
            imageurls: [],
            topics: [],
            errors: [],
            showModal: false,
            Moduls: [],
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            kelas: [],
            headers: ["Nama", "Mapel", "Kelas", "Status", "Created At"],
            headersKey: ["name", "mapel", "grades", "status", "createdAt"],
            topic: null,
            babId: null,
            subBabId: null,
            subSubBabId: null,
            // Nama bab dari detail modul, dipakai sebelum daftar topik dimuat
            babName: "",
            // Kelas yang daftar urutannya sedang ditampilkan di dialog
            orderGrade: null,
            imageFile: [],
            imageArray: [],
            previewUrl: null,
            sbab: "",
            modul2: [],
            loadingSequence: false,
            updatedSequence: false,
            // Urutan modul lain per kelas, dikirim setelah modul ini tersimpan
            // (modul ini belum ada di urutan bab + kelas tersebut di server)
            pendingOrder: {},
            lastSequence: 0,
            video_url: null,
            subtest: { item_count: 0 },
            ssbab: "",
            sssbab: "",
            jenjangList: ["SD", "SMP", "SMA"],
            gradesByJenjang: {
                SD: [1, 2, 3, 4, 5, 6],
                SMP: [7, 8, 9],
                SMA: [10, 11, 12],
            },
            mapelList: JSON.parse(localStorage.getItem("mapels")) || [],
            changedUrl: false,
            dialogConfirm: {
                open: false,
                title: null,
                subtitle: null,
            },
            user_groups: [],
            mapel: "",
        };
    },

    // watch: {
    //     mapel() {
    //         this.getItembanks();
    //     },
    // },

    computed: {
        gradejenjang() {
            switch (Number(this.form.jenjang)) {
                case 0:
                    return [4, 5, 6];
                    break;
                case 1:
                    return [7, 8, 9];
                    break;
                case 2:
                    return [10, 11, 12];
                    break;
                default:
                    return [4, 5, 6];
                    break;
            }
        },

        validGrades() {
            return this.gradesByJenjang[this.form.jenjang] || [];
        },

        // Kelas yang benar-benar dikirim: angka unik dan sesuai jenjang
        selectedGrades() {
            var valid = this.validGrades;
            return _.sortBy(
                _.uniq(this.kelas.map(this.normalizeGrade)).filter(
                    (grade) => valid.indexOf(grade) !== -1
                )
            );
        },

        currentBabName() {
            var context = this;
            var bab = this.topics.find((topic) => topic.id == context.babId);
            return bab ? bab.nama : this.babName;
        },

        canOrder() {
            return !!(
                this.mapel &&
                this.mapel.nama &&
                this.babId &&
                this.currentBabName &&
                this.selectedGrades.length > 0
            );
        },
    },

    methods: {
        resetKelas() {
            this.kelas = [];
            // Kelompok bab + kelas berubah, nomor urut lama tidak berlaku
            this.form.module_order = "";
            this.pendingOrder = {};
        },

        // API bisa mengirim kelas sebagai angka, string, atau objek { grade }
        normalizeGrade(grade) {
            return Number(
                grade && typeof grade === "object" ? grade.grade : grade
            );
        },

        jenjangByGrade(grade) {
            var context = this;
            return (
                Object.keys(this.gradesByJenjang).find(
                    (jenjang) =>
                        context.gradesByJenjang[jenjang].indexOf(grade) !== -1
                ) || ""
            );
        },

        onFileChange(e) {
            const file = e.target.files[0];
            if (!file) return;

            if (file.type.indexOf("pdf") == -1) {
                e.target.value = "";
                this.$store.commit("showAlert", {
                    message: "Format file tidak didukung",
                    submessage: "File yang diunggah harus berformat PDF",
                    type: "error",
                });
                return;
            }

            this.pdfFile = file;
            this.fileName2 = file.name;
            this.presentationPath = URL.createObjectURL(file);
        },

        async upload(e) {
            this.isLoading = true;

            const mapel_id = this.form.subject;

            if (this.validateForm()) {
                var file = this.pdfFile;
                if (this.presentationPath && !file) {
                    this.save();
                } else {
                    if (!file) {
                        this.isLoading = false;
                        return;
                    }

                    try {
                        await applyOssCredentials(AWS);
                    } catch (error) {
                        this.$store.commit("showAlert", {
                            message: `Terjadi kesalahan pada upload!`,
                            submessage: error.message,
                            type: "error",
                        });
                        this.isLoading = false;
                        return;
                    }

                    var spaceEndpoint = process.env.VUE_APP_OSS_END_POINT; // 'oss-ap-southeast-5.aliyuncs.com'
                    var bucket = new AWS.S3({
                        endpoint: spaceEndpoint,
                    });

                    var fileExt = file.name.substr(-4);
                    var filename = uniqid() + fileExt;
                    var params = {
                        Bucket: process.env.VUE_APP_OSS_BUCKET, // 'bonf-files',
                        Key: `modules/${mapel_id}/${file.name}`,
                        Body: file,
                        ContentType: file.type,
                        ACL: "public-read",
                    };

                    var context = this;
                    bucket.upload(params, function (error, data) {
                        if (error) {
                            context.$store.commit("showAlert", {
                                message: `Terjadi kesalahan pada upload!`,
                                submessage: error,
                                type: "error",
                            });
                            context.isLoading = false;
                        } else {
                            context.presentationPath = data.Location;
                            context.save();
                        }
                    });
                }
            } else {
                this.isLoading = false;
            }
        },

        validateForm: function () {
            var context = this;
            var valid = this.$refs.form.validate();

            if (!valid) {
                this.$store.commit("showAlert", {
                    message: "Data belum lengkap",
                    submessage: "Lengkapi kolom yang wajib diisi",
                    type: "error",
                });

                // Arahkan ke kolom pertama yang masih error
                this.$nextTick(function () {
                    var firstError = context.$el.querySelector(
                        ".v-input.error--text"
                    );
                    if (firstError) {
                        firstError.scrollIntoView({
                            behavior: "smooth",
                            block: "center",
                        });
                    }
                });
            }

            return valid;
        },

        findmapel(data) {
            const found = this.mapelList.find((mapel) => mapel.nama == data);
            return found;
        },

        onSubmit() {
            if (this.$route.query.id) {
                this.upload();
            } else {
                this.upload();
            }
        },

        save() {
            var context = this;

            if (!this.validateForm()) {
                this.isLoading = false;
                return;
            }

            if (this.form.module_order) {
                this.submit();
                return;
            }

            // Modul tanpa nomor urut ditaruh di urutan terakhir bab + kelas yang sama
            this.fetchGroupModuls(this.selectedGrades[0], function (modules) {
                if (!modules) {
                    context.isLoading = false;
                    return;
                }

                var currentId = context.$route.query.id;
                var lastOrder = modules
                    .filter((modul) => !currentId || modul.id != currentId)
                    .reduce(
                        (max, modul) =>
                            Math.max(max, Number(modul.module_order) || 0),
                        0
                    );
                context.form.module_order = lastOrder + 1;
                context.submit();
            });
        },

        submit() {
            var context = this;

            // Hasil dari API berupa objek, pilihan baru berupa id, slot baru berupa ""
            var userGroupIds = (this.form.user_group || [])
                .map((group) =>
                    group && typeof group === "object" ? group.id : group
                )
                .filter((id) => id !== "" && id !== null && id !== undefined);

            var data = {
                name: this.form.name,
                subject: this.form.subject,
                url: this.presentationPath,
                jenjang: this.form.jenjang,
                semester: this.form.semester,
                grades: this.selectedGrades,
                password: this.form.password,
                kurikulum: this.form.kurikulum,
                status_user: this.form.status_user,
                user_group: userGroupIds,
                reading_material: this.form.reading_material,
                module_order: Number(this.form.module_order),
                bab: this.babId,
                sub_bab: this.subBabId,
                sub_sub_bab: this.subSubBabId,
                status: this.form.status,
            };

            var onSaved = function (response) {
                if (
                    response.success &&
                    response.data.description != "Failed to Record Data"
                ) {
                    context.applyPendingOrder();
                    context.$store.commit("showAlert", {
                        message: `Berhasil Menyimpan Data!`,
                        type: "success",
                    });
                    context.$router.push("/modul-pembelajaran");
                } else {
                    context.$store.commit("showAlert", {
                        message: response.success
                            ? `Terjadi kesalahan`
                            : `Gagal menyimpan data`,
                        submessage: "Data tidak tersimpan",
                        type: "error",
                    });
                }
                context.isLoading = false;
            };

            if (this.$route.query.id) {
                data.id = this.$route.query.id;
                ModulPembelajaranService.editModulPembelajaran(data, onSaved);
            } else {
                ModulPembelajaranService.createModulPembelajaran(
                    data,
                    function (response) {
                        onSaved(response);
                        context.$store.commit("reset_modul_pembelajaran");
                    }
                );
            }
        },

        // Modul pada bab + kelas yang sama, urut sesuai nomor urut dari API.
        // Callback menerima null bila gagal dimuat.
        fetchGroupModuls(grade, callback) {
            var context = this;

            if (!this.canOrder) {
                this.$store.commit("showAlert", {
                    message: "Nomor urut belum bisa ditentukan",
                    submessage:
                        "Lengkapi Mata Pelajaran, Topik, dan Kelas terlebih dahulu",
                    type: "error",
                });
                callback(null);
                return;
            }

            this.isFetchingModuls = true;

            ModulPembelajaranService.getListModulByBab(
                this.babId,
                grade,
                function (result) {
                    context.isFetchingModuls = false;

                    if (!result.success) {
                        context.$store.commit("showAlert", {
                            message: "Gagal memuat urutan modul",
                            submessage: result.message,
                            type: "error",
                        });
                        callback(null);
                        return;
                    }

                    callback(
                        (result.data.list_module || []).map((modul) => ({
                            id: modul.id,
                            name: modul.nama_module,
                            module_order: Number(modul.module_order) || null,
                        }))
                    );
                }
            );
        },

        openOrderDialog() {
            if (!this.canOrder) {
                this.$store.commit("showAlert", {
                    message: "Urutan modul belum bisa diatur",
                    submessage:
                        "Lengkapi Mata Pelajaran, Topik, dan Kelas terlebih dahulu",
                    type: "error",
                });
                return;
            }

            if (this.selectedGrades.indexOf(this.orderGrade) === -1) {
                this.orderGrade = this.selectedGrades[0];
            }

            this.showModal = true;
            this.loadOrderList();
        },

        loadOrderList() {
            var context = this;
            this.modul2 = [];
            this.updatedSequence = false;

            this.fetchGroupModuls(this.orderGrade, function (modules) {
                if (!modules) return;

                var currentId = context.$route.query.id;
                var list = modules.map((modul) =>
                    currentId && modul.id == currentId
                        ? {
                              ...modul,
                              name: context.form.name || modul.name,
                              current: true,
                              saved: true,
                          }
                        : modul
                );

                // Modul baru / pindah bab belum ada di daftar server:
                // sisipkan sesuai nomor urut di form, atau paling akhir
                if (!list.some((modul) => modul.current)) {
                    var order = Number(context.form.module_order);
                    var position = order
                        ? list.filter(
                              (modul) =>
                                  modul.module_order &&
                                  modul.module_order < order
                          ).length
                        : list.length;

                    list.splice(position, 0, {
                        id: currentId || "current",
                        name: context.form.name || "(Modul ini)",
                        current: true,
                        saved: false,
                    });
                }

                context.modul2 = list;
            });
        },

        // Seperti urutan video: setelah drag, nomor urut = posisi di daftar
        finishDragged() {
            var modul = this.modul2.find((item) => item.current);
            var previousOrder = this.form.module_order;

            var body = this.modul2.map((item, i) => ({
                id: item.id,
                module_order: i + 1,
            }));

            this.form.module_order = this.modul2.indexOf(modul) + 1;

            if (modul.saved) {
                // Dilepas di posisi semula: tidak perlu kirim ke API
                var changed = body.some(
                    (item, i) => this.modul2[i].module_order !== item.module_order
                );
                if (changed) this.changeSequence(body, previousOrder);
                return;
            }

            // Modul ini belum masuk bab + kelas ini di server: urutan modul
            // lain baru dikirim setelah Simpan, supaya tidak berubah bila batal
            this.pendingOrder[this.orderGrade] = body.filter(
                (item) => item.id != modul.id
            );
        },

        changeSequence(body, previousOrder) {
            var context = this;
            this.loadingSequence = true;
            this.updatedSequence = false;

            ModulPembelajaranService.changeSequence(body, function (result) {
                context.loadingSequence = false;

                if (result.success) {
                    context.updatedSequence = true;
                    body.forEach(function (item) {
                        var modul = context.modul2.find(
                            (modul) => modul.id == item.id
                        );
                        if (modul) modul.module_order = item.module_order;
                    });
                    return;
                }

                context.$store.commit("showAlert", {
                    message: `Terjadi kesalahan`,
                    submessage: "Urutan modul tidak berubah",
                    type: "error",
                });
                context.form.module_order = previousOrder;
                context.loadOrderList();
            });
        },

        applyPendingOrder() {
            var context = this;
            var body = _.flatten(_.values(this.pendingOrder));
            this.pendingOrder = {};

            if (!body.length) return;

            ModulPembelajaranService.changeSequence(body, function (result) {
                if (!result.success) {
                    context.$store.commit("showAlert", {
                        message: `Modul tersimpan`,
                        submessage: "Tetapi urutan modul lain gagal diubah",
                        type: "error",
                    });
                }
            });
        },

        assignTopic: function (result) {
            var topicIds = result.data;

            // Pindah bab berarti pindah kelompok urutan
            if (topicIds[0] != this.babId) {
                this.form.module_order = "";
                this.pendingOrder = {};
            }

            this.babId = topicIds[0];
            this.subBabId = topicIds[1];
            this.subSubBabId = topicIds[2];
            this.topic = result.text;
        },

        findmapel(data) {
            const found = this.mapelList.find((mapel) => mapel.id == data);
            return found;
        },

        fetchDetail() {
            var context = this;

            if (this.$route.query.id) {
                this.isFetchingDetail = true;
                this.detailError = false;

                ModulPembelajaranService.getModulBelajar(
                    this.$route.query.id,
                    function (result) {
                        context.isFetchingDetail = false;

                        if (!result.success) {
                            context.detailError = true;
                            context.$store.commit("showAlert", {
                                message: "Gagal memuat data modul",
                                submessage: result.message,
                                type: "error",
                            });
                            return;
                        }

                        if (result.success) {
                            var grades = (result.data.grades || [])
                                .map(context.normalizeGrade)
                                .filter((grade) => !isNaN(grade));

                            // Jenjang dari API bisa berupa string / objek, atau kosong
                            var jenjang = result.data.jenjang;
                            if (jenjang && typeof jenjang === "object") {
                                jenjang = jenjang.nama;
                            }
                            jenjang = jenjang
                                ? String(jenjang).toUpperCase()
                                : "";
                            if (!context.gradesByJenjang[jenjang]) {
                                jenjang = context.jenjangByGrade(grades[0]);
                            }

                            var ModulBelajar = result.data;
                            context.form = ModulBelajar;
                            context.form.jenjang = jenjang;
                            context.form.user_group =
                                ModulBelajar.user_group &&
                                ModulBelajar.user_group.length > 0
                                    ? ModulBelajar.user_group
                                    : [""];
                            // Hanya kelas yang sesuai jenjang, agar yang
                            // tercentang sama dengan yang dikirim saat simpan
                            context.kelas = _.uniq(grades).filter(
                                (grade) =>
                                    (
                                        context.gradesByJenjang[jenjang] || []
                                    ).indexOf(grade) !== -1
                            );

                            context.presentationPath = context.form.url;
                            context.mapel = context.form.subject;

                            context.getItembanks();

                            // API mengirim objek di `sub_bab` / `sub_sub_bab`
                            // (sama seperti di list modul)
                            var babData = result.data.bab;
                            var subBabData =
                                result.data.sub_bab || result.data.sub_bab_id;
                            var subSubBabData =
                                result.data.sub_sub_bab ||
                                result.data.sub_sub_bab_id;

                            context.babId = babData ? babData.id : null;
                            context.babName = babData ? babData.nama : "";
                            context.subBabId = subBabData
                                ? subBabData.id
                                : null;
                            context.subSubBabId = subSubBabData
                                ? subSubBabData.id
                                : null;

                            var bab = babData ? babData.nama : "";
                            var subbab = subBabData
                                ? " >> " + subBabData.nama
                                : "";
                            var subsubbab = subSubBabData
                                ? " >> " + subSubBabData.nama
                                : "";

                            context.topic = bab + subbab + subsubbab;
                        }
                    }
                );
            }
        },

        getMapelById: function (mapelId) {
            return this.mapelList.find(function (element) {
                return element.id == mapelId;
            });
        },

        // `mapel` bisa berupa objek (dipilih dari select) atau id (dari detail modul)
        getItembanks() {
            if (!this.mapel) return;

            var mapelId =
                typeof this.mapel === "object" ? this.mapel.id : this.mapel;
            var found = this.getMapelById(mapelId);
            if (!found) return;

            this.mapel = found;
            this.form.subject = found.id;
            this.getTopics(found.code);
        },

        getTopics(id) {
            var context = this;

            ItembankService.getListOfTopic(id, function (result) {
                context.topics = result.success ? result.data || [] : [];
            });
        },

        getTopicText: function (subtestDetail) {
            if (this.topics.length == 0) return;

            var text = "";
            var chapter = this.topics.find(function (element) {
                return element.kode == parseInt(subtestDetail.bab_code);
            });

            text += chapter.nama;

            if (subtestDetail.sub_bab_code) {
                var subChapter = chapter.subs.find(function (element) {
                    return element.kode == parseInt(subtestDetail.sub_bab_code);
                });

                text += " >> " + subChapter.nama;
            }

            return text;
        },

        getUserGroupData() {
            this.user_groups = [];
            const url =
                process.env.API_BASE_URL +
                "/payment/list/user_group?page=1&per_page=1000";

            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };
            const context = this;
            this.isFetchingUserGroups = true;
            axios
                .get(url, options)
                .then(function (response) {
                    if (response.status === 200) {
                        context.user_groups = response.data.user_groups || [];
                    }
                })
                .catch(function (error) {
                    context.$store.commit("showAlert", {
                        message: "Gagal memuat data user group",
                        submessage: error.message,
                        type: "error",
                    });
                })
                .then(function () {
                    context.isFetchingUserGroups = false;
                });
        },
    },

    mounted: function () {
        if (this.$route.query.id) {
            this.fetchDetail();
        }
        this.getUserGroupData();
    },
};
</script>

<style scoped>
#preview {
    display: flex;
    justify-content: center;
    align-items: center;
}

#preview img {
    max-width: 100%;
    max-height: 200px;
}

#preview iframe {
    max-width: 100%;
    max-height: 200px;
}

.pdf-card {
    overflow: hidden;
}

.pdf-preview {
    display: block;
    width: 80%;
    height: 560px;
    margin: 16px auto;
}

/* Urutan modul (sama seperti urutan video) */
.draggable {
    cursor: all-scroll !important;
}

.selected {
    background-color: #00897b;
    color: #fff !important;
    border-radius: 8px;
}

.ghost {
    opacity: 1;
    background: #ececec;
}
</style>



// WEBPACK FOOTER //
// Form.vue?cde58e18